import { toastType } from '~/types/toast.type'

const toast = ref<toastType>({
  message: '',
  status: 'NULL',
})

export const useToasts = () => {
  const setToast = (toastParam?: toastType) => {
    toast.value.message = toastParam?.message || ''
    toast.value.status = toastParam?.status || 'NULL'
  }

  const showToast = (toastParam: toastType) => {
    setToast(toastParam)
    let timerId
    if (timerId) {
      clearTimeout(timerId)
      timerId = null
    }
    setTimeout(() => {
      closeToast()
    }, 5000)
  }

  const closeToast = () => {
    setToast()
  }

  return { toast, showToast, closeToast }
}


